/* ═══════════════════════════════════════════════════════════════
   TAQWA ARTS — Glass Modern Theme JS
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  /* ── Header scroll effect ── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile menu ── */
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.header-nav');
  const overlay = document.querySelector('.nav-overlay');

  if (menuToggle && nav) {
    const openMenu = () => {
      nav.classList.add('open');
      menuToggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const closeMenu = () => {
      nav.classList.remove('open');
      menuToggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    menuToggle.addEventListener('click', () => {
      nav.classList.contains('open') ? closeMenu() : openMenu();
    });

    if (overlay) overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('open')) closeMenu();
    });
  }

  /* ── Scroll reveal ── */
  /* SPEED 2026-10-07: normally already started by the inline script at the end of layout/theme.liquid. */
  const reveals = window.__asReveal ? [] : document.querySelectorAll('.reveal');
  if (window.__asReveal) {
    /* started inline */
  } else if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px 0px 0px' }
    );
    reveals.forEach((el) => observer.observe(el));

    /* Safari fallback: if elements are still hidden after 800ms, force-show them */
    setTimeout(() => {
      reveals.forEach((el) => {
        if (!el.classList.contains('visible')) {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight + 50) {
            el.classList.add('visible');
          }
        }
      });
    }, 800);
  } else {
    /* No IntersectionObserver — show everything */
    reveals.forEach((el) => el.classList.add('visible'));
  }

  /* ── Collection description: Read more toggle ── */
  const descToggle = document.querySelector('.collection-desc-toggle');
  const descBox = document.getElementById('collection-desc');
  if (descToggle && descBox) {
    /* SPEED 2026-10-07: the button is rendered (space reserved, .is-pending = invisible) so showing it shifts nothing. */
    if (descBox.scrollHeight > descBox.clientHeight + 4) {
      descToggle.classList.remove('is-pending');
      descToggle.addEventListener('click', () => {
        const open = descBox.classList.toggle('is-open');
        descToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        descToggle.textContent = open ? 'Read less' : 'Read more';
      });
    } else {
      descBox.classList.remove('collection-desc--clamp');
    }
  }

  /* ── Category filter pills ── */
  const filterContainer = document.getElementById('category-filters');
  if (filterContainer) {
    const pills = filterContainer.querySelectorAll('.filter-pill');
    const cards = document.querySelectorAll('.product-card[data-product-type]');
    const resultCount = document.querySelector('.collection-result-count');

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const type = pill.dataset.type;

        // Update active state
        pills.forEach((p) => p.classList.remove('active'));
        pill.classList.add('active');

        // Filter cards
        let visible = 0;
        cards.forEach((card) => {
          if (type === 'all' || card.dataset.productType === type) {
            card.classList.remove('product-card--hidden');
            visible++;
          } else {
            card.classList.add('product-card--hidden');
          }
        });

        // Show/hide category group headers — only keep the active one visible
        const groupHeaders = document.querySelectorAll('.category-group-header');
        groupHeaders.forEach((header) => {
          if (type === 'all') {
            header.style.display = '';
            return;
          }
          const titleEl = header.querySelector('.category-group-title');
          if (!titleEl) { header.style.display = 'none'; return; }
          // Handleize the header title the same way Shopify does for data-product-type
          const headerType = titleEl.textContent.trim().toLowerCase()
            .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          header.style.display = headerType === type ? '' : 'none';
        });

        // Update count
        if (resultCount) {
          resultCount.textContent = 'Showing ' + visible + ' ' + (visible === 1 ? 'product' : 'products');
        }

        // Update category group header counts to match filtered state
        document.querySelectorAll('.category-group-header').forEach((groupHeader) => {
          const titleEl = groupHeader.querySelector('.category-group-title');
          const countEl = groupHeader.querySelector('.category-group-count');
          if (!titleEl || !countEl) return;
          const groupType = titleEl.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const visibleInGroup = Array.from(cards).filter(
            (c) => !c.classList.contains('product-card--hidden') && c.dataset.productType === groupType
          ).length;
          countEl.textContent = visibleInGroup + ' ' + (visibleInGroup === 1 ? 'product' : 'products');
        });
      });
    });
  }

  /* ── Sort dropdown handler ── */
  const sortSelect = document.getElementById('sort-select');
  const grid = document.getElementById('product-grid');
  if (sortSelect && grid) {
    sortSelect.addEventListener('change', () => {
      const val = sortSelect.value;

      if (val === 'by-category') {
        // Reset filter pills and show all cards before grouping
        const filterWrap = document.getElementById('category-filters');
        if (filterWrap) {
          filterWrap.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
          const allPill = filterWrap.querySelector('.filter-pill[data-type="all"]');
          if (allPill) allPill.classList.add('active');
        }
        grid.querySelectorAll('.product-card').forEach(c => c.classList.remove('product-card--hidden'));

        // Remove any existing category headers
        grid.querySelectorAll('.category-group-header').forEach(h => h.remove());

        const cards = Array.from(grid.querySelectorAll('.product-card[data-product-type]'));

        // Group cards by product type
        const groups = {};
        cards.forEach(card => {
          const type = card.dataset.productTypeLabel || card.dataset.productType || 'Other';
          if (!groups[type]) groups[type] = [];
          groups[type].push(card);
        });

        // Sort group names alphabetically
        const sortedTypes = Object.keys(groups).sort();

        // Reorder DOM: insert header + cards for each group
        sortedTypes.forEach(type => {
          const header = document.createElement('div');
          header.className = 'category-group-header reveal visible';
          const title = document.createElement('h2');
          title.className = 'category-group-title';
          title.textContent = type;
          const count = document.createElement('span');
          count.className = 'category-group-count';
          // Collection-level total for this type (the grid only holds the current page).
          let totals = {};
          try { totals = JSON.parse(grid.dataset.typeTotals || '{}'); } catch (e) { totals = {}; }
          const typeKey = (groups[type][0] && groups[type][0].dataset.productType) || '';
          const n = groups[type].length;
          const total = totals[typeKey];
          count.textContent = (total && total > n)
            ? n + ' of ' + total + ' products (more on other pages)'
            : n + ' ' + (n === 1 ? 'product' : 'products');
          header.appendChild(title);
          header.appendChild(count);
          grid.appendChild(header);
          groups[type].forEach(card => grid.appendChild(card));
        });
      } else {
        // Navigate to sort URL
        window.location.href = val;
      }
    });

    // Trigger category grouping on initial load if "By Category" is selected
    if (sortSelect.value === 'by-category') {
      sortSelect.dispatchEvent(new Event('change'));
    }
  }

  /* ── Product variant selector ── */
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const variantsJson = document.getElementById('product-variants-json');
  if (productForm && variantsJson) {
    const variants = JSON.parse(variantsJson.textContent);
    const variantSelect = productForm.querySelector('select[name="id"]');
    const radios = productForm.querySelectorAll('input[type="radio"]');
    const selects = productForm.querySelectorAll('.product-option select');
    const priceEls = document.querySelectorAll('.product-price');
    const addBtn = productForm.querySelector('.add-to-cart-btn');

    function getSelectedOptions() {
      const opts = [];
      productForm.querySelectorAll('.product-option').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) { opts.push(checked.value); return; }
        const sel = group.querySelector('select');
        if (sel) opts.push(sel.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find((v) =>
        v.options.length === opts.length && v.options.every((o, i) => o === opts[i])
      );
    }

    // Products with several options don't offer every combination (e.g. 10 styles x
    // 10 colours x 7 sizes = 700 combos but only 250 variants). Disable values that
    // don't exist for the choices made above them, and move the selection to the
    // first value that does (preferring one in stock), so the form never submits a
    // stale variant id.
    const groups = Array.from(productForm.querySelectorAll('.product-option'));
    function refreshAvailability() {
      const chosen = [];
      groups.forEach((group, i) => {
        const inputs = Array.from(group.querySelectorAll('input[type="radio"], select option'));
        const matches = (v, val) => v.options[i] === val && chosen.every((c, j) => v.options[j] === c);
        const exists = (val) => variants.some((v) => matches(v, val));
        const hasAvail = (val) => variants.some((v) => v.available && matches(v, val));
        let firstOk = null, firstAvail = null;
        inputs.forEach((el) => {
          const ok = exists(el.value);
          el.disabled = !ok;
          if (ok && !firstOk) firstOk = el;
          if (ok && !firstAvail && hasAvail(el.value)) firstAvail = el;
        });
        const pick = firstAvail || firstOk;
        const sel = group.querySelector('select');
        const radio = group.querySelector('input[type="radio"]:checked');
        if (sel && sel.selectedOptions[0] && sel.selectedOptions[0].disabled && pick) sel.value = pick.value;
        if (!sel && (!radio || radio.disabled) && pick) pick.checked = true;
        chosen.push(sel ? sel.value : (group.querySelector('input[type="radio"]:checked') || {}).value);
      });
    }

    // Owner 2026-10-03: picking a photo of a colour selects that colour (and keeps the closest size).
    const groupName = (g) => ((g.querySelector('legend, label') || {}).textContent || '').trim().toLowerCase();
    const colourIdx = groups.findIndex((g) => /^colou?r$/.test(groupName(g)));
    const sizeIdx = groups.findIndex((g) => groupName(g) === 'size');
    let fromGallery = false;
    const groupValues = (g) => Array.from(g.querySelectorAll('input[type="radio"], select option')).map((el) => el.value);
    function setGroup(g, val) {
      const sel = g.querySelector('select');
      if (sel) { sel.value = val; return; }
      const r = Array.from(g.querySelectorAll('input[type="radio"]')).find((el) => el.value === val);
      if (r) r.checked = true;
    }
    document.addEventListener('theme:select-colour', (e) => {
      if (colourIdx < 0 || !e.detail || !e.detail.colour) return;
      const want = e.detail.colour;
      const opts = getSelectedOptions();
      if (opts[colourIdx] === want) return;
      const inColour = variants.filter((v) => v.options[colourIdx] === want && v.options.every((o, i) => i === colourIdx || i === sizeIdx || o === opts[i]));
      if (!inColour.length) return;
      setGroup(groups[colourIdx], want);
      if (sizeIdx >= 0) {
        const order = groupValues(groups[sizeIdx]);
        const cur = order.indexOf(opts[sizeIdx]);
        const score = (v) => Math.abs(order.indexOf(v.options[sizeIdx]) - cur) + (v.available ? 0 : 100);
        const best = inColour.slice().sort((a, b) => score(a) - score(b))[0];
        setGroup(groups[sizeIdx], best.options[sizeIdx]);
      }
      fromGallery = true;
      onVariantChange();
      fromGallery = false;
      const live = document.getElementById('as-colour-live');
      if (live) live.textContent = 'Colour ' + want + ' selected' + (sizeIdx >= 0 ? ', size ' + getSelectedOptions()[sizeIdx] : '');
    });

    function onVariantChange() {
      if (groups.length > 1) refreshAvailability();
      const opts = getSelectedOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      // Update hidden select
      if (variantSelect) variantSelect.value = variant.id;

      // Update price (both mobile and desktop elements)
      // price_html is formatted by Liquid (| money), so it carries the visitor's
      // presentment currency instead of a hard-coded USD label.
      if (variant.price_html) priceEls.forEach((el) => { el.textContent = variant.price_html; });

      // Update button
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Keep ?variant= in the URL (shareable, and what Shopify reads on reload)
      try {
        const u = new URL(window.location.href);
        if (u.searchParams.get('variant') !== String(variant.id)) {
          u.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', u.toString());
        }
      } catch (err) { /* old browsers: skip */ }

      // Activate matching thumbnail in gallery (not when the change came from clicking a photo)
      if (variant.featured_media_id && !fromGallery) {
        const targetThumb = document.querySelector('#product-media-thumbs .product-thumb[data-media-id="' + variant.featured_media_id + '"]');
        if (targetThumb) targetThumb.click();
      }
    }

    radios.forEach((radio) => radio.addEventListener('change', onVariantChange));
    selects.forEach((sel) => sel.addEventListener('change', onVariantChange));

    // Sync once on load, and again when the page is restored from the
    // back/forward cache (browsers restore radio/select state, which can
    // drift from the hidden variant id).
    // (setTimeout: run after the gallery below has bound its thumbnail clicks.)
    if (groups.length) setTimeout(onVariantChange, 0);
    window.addEventListener('pageshow', (e) => { if (e.persisted && groups.length) onVariantChange(); });
  }

  /* ── Product image gallery + lightbox ── */
  const mainImg = document.getElementById('product-media-main-img');
  const thumbsWrap = document.getElementById('product-media-thumbs');
  const zoomBtn = document.getElementById('product-media-zoom');
  const lightbox = document.getElementById('product-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxClose = document.getElementById('lightbox-close');
  const lightboxPrev = document.getElementById('lightbox-prev');
  const lightboxNext = document.getElementById('lightbox-next');
  const lightboxBackdrop = document.getElementById('lightbox-backdrop');

  if (mainImg) {
    const thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.product-thumb')) : [];
    let galleryIndex = 0;

    // Owner 2026-10-04: show the colour of the photo being viewed on the main image.
    // Only photos with a known colour (data-colour from the variant/photo mapping) get a label; others show none.
    const colourTag = document.getElementById('product-media-colour');
    const showColour = (thumb) => {
      if (!colourTag) return;
      const c = thumb && thumb.dataset.colour;
      const text = c ? c + (thumb.dataset.side ? ' \u00b7 ' + thumb.dataset.side : '') : '';
      if (colourTag.textContent !== text) colourTag.textContent = text;
      colourTag.hidden = !text;
    };

    const activateThumb = (index) => {
      if (!thumbs.length) return;
      galleryIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      thumbs.forEach((t, i) => {
        const active = i === galleryIndex;
        t.classList.toggle('product-thumb--active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const active = thumbs[galleryIndex];
      // The main image has a srcset, so swap it too (src alone would be ignored).
      if (active.dataset.srcset) mainImg.srcset = active.dataset.srcset;
      mainImg.src = active.dataset.src;
      mainImg.alt = active.dataset.alt || '';
      showColour(active);
      if (lightboxImg) { lightboxImg.src = active.dataset.src; lightboxImg.alt = active.dataset.alt || ''; }
      // Scroll only the thumbnail strip (and only when it scrolls sideways);
      // scrollIntoView moved the whole window away from the buy button.
      if (thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 1) {
        thumbsWrap.scrollTo({ left: active.offsetLeft - (thumbsWrap.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
      }
    };

    const pickColour = (thumb) => {
      if (thumb && thumb.dataset.colour) {
        document.dispatchEvent(new CustomEvent('theme:select-colour', { detail: { colour: thumb.dataset.colour } }));
      }
    };
    // e.isTrusted: a real click / Enter / Space by the visitor (variant changes also "click" the thumb in code).
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', (e) => { activateThumb(i); if (e.isTrusted) pickColour(thumb); }));
    showColour(thumbs[0]);

    // Touch: swipe the main image left/right for the next/previous photo (like the lightbox arrows).
    const mainWrap = document.getElementById('product-media-main');
    if (mainWrap && thumbs.length > 1) {
      let sx = null, sy = 0;
      mainWrap.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) { sx = null; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      mainWrap.addEventListener('touchend', (e) => {
        if (sx === null || !e.changedTouches.length) return;
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < 1.5 * Math.abs(dy)) return;
        activateThumb(galleryIndex + (dx < 0 ? 1 : -1));
        pickColour(thumbs[galleryIndex]);
      }, { passive: true });
    }

    if (lightbox) {
      const openLightbox = () => {
        if (lightboxImg && mainImg.src) {
          lightboxImg.src = (thumbs[galleryIndex] && thumbs[galleryIndex].dataset.src) || mainImg.currentSrc || mainImg.src;
          lightboxImg.alt = mainImg.alt || '';
        }
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lightboxClose && lightboxClose.focus();
      };
      const closeLightbox = () => {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        zoomBtn && zoomBtn.focus();
      };

      zoomBtn && zoomBtn.addEventListener('click', openLightbox);
      lightboxClose && lightboxClose.addEventListener('click', closeLightbox);
      lightboxBackdrop && lightboxBackdrop.addEventListener('click', closeLightbox);
      lightboxPrev && lightboxPrev.addEventListener('click', () => { activateThumb(galleryIndex - 1); pickColour(thumbs[galleryIndex]); });
      lightboxNext && lightboxNext.addEventListener('click', () => { activateThumb(galleryIndex + 1); pickColour(thumbs[galleryIndex]); });

      if (thumbs.length <= 1) {
        if (lightboxPrev) lightboxPrev.hidden = true;
        if (lightboxNext) lightboxNext.hidden = true;
      }

      document.addEventListener('keydown', (e) => {
        if (!lightbox || lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && thumbs.length > 1) activateThumb(galleryIndex - 1);
        if (e.key === 'ArrowRight' && thumbs.length > 1) activateThumb(galleryIndex + 1);
      });
    }
  }

  /* ── Quantity +/- buttons (product page & cart) ── */
  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      const min = parseInt(input.min) || 0;
      const val = parseInt(input.value) || 1;
      if (val > min) input.value = val - 1;
    });
    plus.addEventListener('click', () => {
      const max = parseInt(input.max) || 99;
      const val = parseInt(input.value) || 1;
      if (val < max) input.value = val + 1;
    });
  });
});
